<template>
  <router-link class="btn btn-icon" :to="to" :aria-label="label">
    <span aria-hidden="true" class="btn-icon-mark">+</span>
  </router-link>
</template>

<script setup>
defineProps({
  to: {
    type: [Object, String],
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
})
</script>
